import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCharity = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "70%",
	height: "100%",
	viewBox: "0 0 43 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M0 18H8V40H0V18ZM30 2.5C31.3 0.98 33.32 0 35.4 0C39.1 0 42 2.9 42 6.6C42 11.14 36.18 16.4 30 22C23.82 16.38 18 11.12 18 6.6C18 2.9 20.9 0 24.6 0C26.68 0 28.7 0.98 30 2.5ZM38 30H24L19.82 28.54L20.48 26.66L24 28H29.64C30.94 28 32 26.94 32 25.64C32 24.66 31.38 23.78 30.46 23.42L15.94 18H12V36.04L26 40L42.02 34C42 31.8 40.22 30 38 30Z" })]
});
const ForwardRef = forwardRef(SvgCharity);
export { ForwardRef as ReactComponent };
